import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const addUserSkill = createAsyncThunk(
    '/add/addUserSkill',
    async (add) => {

        try {
            const myurl = `${PAY_URL}/user/manage-skill`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: add,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const addUserSkill = response.data;
            // console.log(addUserSkill, '@@@')

            if (addUserSkill.success === true) {
                toast.success(addUserSkill?.message);
                return addUserSkill;
            } else {
                // console.log(addUserSkill.message, "&&&&")
                throw new Error(addUserSkill.message);
            }
        } catch (error) {
            // console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const addUserSkillSlice = createSlice({
    name: "addUserSkill",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addUserSkill.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUserSkill.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addUserSkill.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default addUserSkillSlice.reducer;